import { Show } from 'solid-js';
import Text from './Text';
import styles from './PlayerState.module.css';

export interface PlayerStateSnapshot {
  health: number;
  food: number;
  saturation: number;
  experienceBar: number;
  experienceLevel: number;
  totalExperience: number;
  gamemode: number;
  gamemodeName: string;
  x?: number;
  y?: number;
  z?: number;
  speed?: number;
}

interface PlayerStateProps {
  state: PlayerStateSnapshot | null;
}

function pct(value: number, max: number): string {
  const p = Math.max(0, Math.min(1, value / max));
  return `${Math.round(p * 100)}%`;
}

export default function PlayerState(props: PlayerStateProps) {
  const s = () => props.state;

  return (
    <Show
      when={s()}
      fallback={
        <div class={styles.card}>
          <div style={{ color: 'var(--dark-text-muted)', 'font-size': '13px' }}>
            <Text val="PLAYER_STATE_WAITING" />
          </div>
        </div>
      }
    >
      {(state) => (
        <div class={styles.card}>
          <div class={styles.barGroup}>
            <div class={styles.barLabel}>
              <span><i class="fa-solid fa-heart" /> <Text val="STAT_HEALTH" /></span>
              <span class={styles.value}>{state().health.toFixed(1)} / 20</span>
            </div>
            <div class={`${styles.bar} ${styles.barHealth}`}>
              <span style={{ width: pct(state().health, 20) }} />
            </div>

            <div class={styles.barLabel} style={{ 'margin-top': '6px' }}>
              <span><i class="fa-solid fa-drumstick-bite" /> <Text val="STAT_HUNGER" /></span>
              <span class={styles.value}>{state().food} / 20</span>
            </div>
            <div class={`${styles.bar} ${styles.barFood}`}>
              <span style={{ width: pct(state().food, 20) }} />
            </div>
          </div>

          <div class={styles.barGroup}>
            <div class={styles.barLabel}>
              <span>
                <i class="fa-solid fa-star" /> XP{' '}
                <span class={styles.levelBadge}>{state().experienceLevel}</span>
              </span>
              <span class={styles.value}>{Math.round(state().experienceBar * 100)}%</span>
            </div>
            <div class={`${styles.bar} ${styles.barXp}`}>
              <span style={{ width: `${Math.round(state().experienceBar * 100)}%` }} />
            </div>
            <div class={styles.barLabel} style={{ 'margin-top': '6px' }}>
              <span><Text val="STAT_TOTAL" /></span>
              <span class={styles.value}>{state().totalExperience}</span>
            </div>
          </div>

          <div class={styles.gamemode}>
            <span class={styles.gamemodeLabel}><Text val="STAT_MODE" /></span>
            <span class={styles.gamemodeValue}>{state().gamemodeName}</span>
            <Show when={state().x != null}>
              <div class={styles.posRow}>
                <i class="fa-solid fa-location-dot" />
                <span>{Math.floor(state().x!)}</span>
                <span>{Math.floor(state().y!)}</span>
                <span>{Math.floor(state().z!)}</span>
              </div>
              <Show when={(state().speed ?? 0) > 0.01}>
                <div class={styles.speedRow}>
                  <i class="fa-solid fa-gauge-high" />
                  <span>{state().speed?.toFixed(1)} m/s</span>
                </div>
              </Show>
            </Show>
          </div>
        </div>
      )}
    </Show>
  );
}
